import React, { useEffect, useRef, useState } from 'react';
import { navigate } from 'gatsby';
import { useAnalytics } from '../../../../../utils/analytics-provider/analytics-provider';
import { StyledAutocomplete } from './styles';
import Suggestion from './suggestion';
import { useSearchState } from '../../../context';
import { isClient } from '../../../../../utils/is-client';
import { useTimerDelay } from '../../../../../utils/use-timer-delay';

const DEFAULT_PLACEHOLDER = 'Ask Anything';

const SearchField = ({
  placeholder: placeholderProp,
  autocomplete = false,
  updateQueryParam = true
}) => {
  const { query, results, onSearchChange, shouldUpdateQueryParam } = useSearchState();
  const { trackEvent } = useAnalytics();
  const inputRef = useRef();
  const [placeholder, setPlaceholder] = useState(placeholderProp || DEFAULT_PLACEHOLDER);

  useEffect(() => {
    setPlaceholder(placeholderProp || DEFAULT_PLACEHOLDER);
  }, [placeholderProp]);

  const suggestions = results;
  useTimerDelay(() => {
    if (Boolean(query)) {
      trackEvent('search_terms_and_results', {
        data: {
          resultsTotal: suggestions?.length,
          query,
          results,
          source: 'auto_complete'
        }
      });
    }
  }, [suggestions, query]);

  useEffect(() => {
    shouldUpdateQueryParam(updateQueryParam);
  }, [shouldUpdateQueryParam, updateQueryParam]);

  const handleTextSearch = (event) => {
    const {
      key,
      target: { value }
    } = event;
    if (key === 'Enter' && value?.length > 3) updateQueryParams(value);
  };

  useEffect(() => {
    if (inputRef && inputRef.current) {
      const { current } = inputRef;
      current.addEventListener('keydown', handleTextSearch);
      return () => {
        current.removeEventListener('keydown', handleTextSearch);
      };
    }
  });

  const updateQueryParams = (value) => {
    if (!value || !isClient()) return;

    const params = new URLSearchParams(window.location.search);
    params.set('query', value);
    navigate(`/search?${params.toString()}`);
  };

  const selectOption = (value) => {
    const suggestion = suggestions.find((x) => x.id === value);
    const updatedSuggestion = { ...suggestion };
    typeof updatedSuggestion.topic === 'string' &&
      (updatedSuggestion.topic = { topic_url: updatedSuggestion.topic });

    trackEvent('content_engagement_v2', {
      engagement_type: 'result_link_click',
      link: `/${updatedSuggestion.topic.topic_url}/${updatedSuggestion.url}`,
      data: updatedSuggestion
    });
    navigate(`/${updatedSuggestion.topic.topic_url}/${updatedSuggestion.url}`);
  };

  return (
    <StyledAutocomplete
      id="autocomplete-search"
      placeholder={placeholder}
      changeCallback={onSearchChange}
      onSelection={selectOption}
      initialInputValue={query}
      ref={inputRef}
    >
      {autocomplete &&
        suggestions.map((a) => <Suggestion key={a.id} value={a.id} suggestion={a} query={query} />)}
    </StyledAutocomplete>
  );
};

export default SearchField;
